var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _get = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
!function (t) {
  var e = t.en = t.en || {};
  e.dictionary = Object.assign(e.dictionary || {}, {
    "Saving changes": "Saving changes"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function () {
  var t = {
      704: function _(t, e, i) {
        t.exports = i(79)("./src/core.js");
      },
      209: function _(t, e, i) {
        t.exports = i(79)("./src/utils.js");
      },
      79: function _(t) {
        "use strict";

        t.exports = CKEditor5.dll;
      }
    },
    e = {};
  function i(n) {
    var s = e[n];
    if (void 0 !== s) return s.exports;
    var o = e[n] = {
      exports: {}
    };
    return t[n](o, o.exports, i), o.exports;
  }
  i.d = function (t, e) {
    for (var n in e) {
      i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
        enumerable: !0,
        get: e[n]
      });
    }
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (function () {
    "use strict";

    i.r(n), i.d(n, {
      Autosave: function Autosave() {
        return D;
      }
    });
    var t = i(704),
      e = i(209);
    var s = function s(t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    };
    var o = "object" == typeof global && global && global.Object === Object && global;
    var r = "object" == typeof self && self && self.Object === Object && self;
    var a = o || r || Function("return this")();
    var c = function c() {
      return a.Date.now();
    };
    var u = /\s/;
    var d = function d(t) {
      for (var e = t.length; e-- && u.test(t.charAt(e));) {
        ;
      }
      return e;
    };
    var l = /^\s+/;
    var h = function h(t) {
      return t ? t.slice(0, d(t) + 1).replace(l, "") : t;
    };
    var v = a.Symbol;
    var f = Object.prototype,
      m = f.hasOwnProperty,
      g = f.toString,
      p = v ? v.toStringTag : void 0;
    var _ = function _(t) {
      var e = m.call(t, p),
        i = t[p];
      try {
        t[p] = void 0;
        var n = !0;
      } catch (t) {}
      var s = g.call(t);
      return n && (e ? t[p] = i : delete t[p]), s;
    };
    var b = Object.prototype.toString;
    var y = function y(t) {
      return b.call(t);
    };
    var S = v ? v.toStringTag : void 0;
    var j = function j(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : S && S in Object(t) ? _(t) : y(t);
    };
    var O = function O(t) {
      return null != t && "object" == typeof t;
    };
    var T = function T(t) {
      return "symbol" == typeof t || O(t) && "[object Symbol]" == j(t);
    };
    var w = /^[-+]0x[0-9a-f]+$/i,
      P = /^0b[01]+$/i,
      A = /^0o[0-7]+$/i,
      x = parseInt;
    var E = function E(t) {
      if ("number" == typeof t) return t;
      if (T(t)) return NaN;
      if (s(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = s(e) ? e + "" : e;
      }
      if ("string" != typeof t) return 0 === t ? t : +t;
      t = h(t);
      var i = P.test(t);
      return i || A.test(t) ? x(t.slice(2), i ? 2 : 8) : w.test(t) ? NaN : +t;
    };
    var N = Math.max,
      I = Math.min;
    var C = function C(t, e, i) {
      var n,
        o,
        r,
        a,
        u,
        d,
        l = 0,
        h = !1,
        v = !1,
        f = !0;
      if ("function" != typeof t) throw new TypeError("Expected a function");
      function m(e) {
        var i = n,
          s = o;
        return n = o = void 0, l = e, a = t.apply(s, i);
      }
      function g(t) {
        return l = t, u = setTimeout(_, e), h ? m(t) : a;
      }
      function p(t) {
        var i = t - d;
        return void 0 === d || i >= e || i < 0 || v && t - l >= r;
      }
      function _() {
        var t = c();
        if (p(t)) return b(t);
        u = setTimeout(_, function (t) {
          var i = e - (t - d);
          return v ? I(i, r - (t - l)) : i;
        }(t));
      }
      function b(t) {
        return u = void 0, f && n ? m(t) : (n = o = void 0, a);
      }
      function y() {
        var t = c(),
          i = p(t);
        if (n = arguments, o = this, d = t, i) {
          if (void 0 === u) return g(d);
          if (v) return clearTimeout(u), u = setTimeout(_, e), m(d);
        }
        return void 0 === u && (u = setTimeout(_, e)), a;
      }
      return e = E(e) || 0, s(i) && (h = !!i.leading, r = (v = "maxWait" in i) ? N(E(i.maxWait) || 0, e) : r, f = "trailing" in i ? !!i.trailing : f), y.cancel = function () {
        void 0 !== u && clearTimeout(u), l = 0, n = d = o = u = void 0;
      }, y.flush = function () {
        return void 0 === u ? a : b(c());
      }, y;
    };
    var D = /*#__PURE__*/function (_t$Plugin) {
      _inherits(D, _t$Plugin);
      _createClass(D, null, [{
        key: "pluginName",
        get: function get() {
          return "Autosave";
        }
      }, {
        key: "requires",
        get: function get() {
          return [t.PendingActions];
        }
      }]);
      function D(i) {
        var _this;
        _classCallCheck(this, D);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(D).call(this, i));
        var n = i.config.get("autosave") || {},
          s = n.waitingTime || 1e3;
        _this.set("state", "synchronized"), _this._debouncedSave = C(_this._save.bind(_assertThisInitialized(_assertThisInitialized(_this))), s), _this._lastDocumentVersion = i.model.document.version, _this._savePromise = null, _this._domEmitter = Object.create(e.DomEmitterMixin), _this._config = n, _this._pendingActions = i.plugins.get(t.PendingActions), _this._makeImmediateSave = !1;
        return _this;
      }
      _createClass(D, [{
        key: "init",
        value: function init() {
          var _this2 = this;
          var t = this.editor,
            e = t.model.document;
          this.listenTo(t, "ready", function () {
            _this2.listenTo(e, "change:data", function (t, e) {
              _this2._saveCallbacks.length && e.isLocal && ("synchronized" === _this2.state && (_this2.state = "waiting", _this2._setPendingAction()), "waiting" === _this2.state && _this2._debouncedSave());
            });
          }), this.listenTo(t, "destroy", function () {
            return _this2._flush();
          }, {
            priority: "highest"
          }), this._domEmitter.listenTo(window, "beforeunload", function (t, e) {
            _this2._pendingActions.hasAny && (e.returnValue = _this2._pendingActions.first.message);
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._domEmitter.stopListening(), _get(_getPrototypeOf(D.prototype), "destroy", this).call(this);
        }
      }, {
        key: "save",
        value: function save() {
          return this._debouncedSave.cancel(), this._save();
        }
      }, {
        key: "_flush",
        value: function _flush() {
          this._debouncedSave.flush();
        }
      }, {
        key: "_save",
        value: function _save() {
          var _this3 = this;
          return this._savePromise ? (this._makeImmediateSave = this.editor.model.document.version > this._lastDocumentVersion, this._savePromise) : (this._setPendingAction(), this.state = "saving", this._lastDocumentVersion = this.editor.model.document.version, this._savePromise = Promise.resolve().then(function () {
            return Promise.all(_this3._saveCallbacks.map(function (t) {
              return t(_this3.editor);
            }));
          }).finally(function () {
            _this3._savePromise = null;
          }).then(function () {
            if (_this3._makeImmediateSave) return _this3._makeImmediateSave = !1, _this3._save();
            _this3.editor.model.document.version > _this3._lastDocumentVersion ? (_this3.state = "waiting", _this3._debouncedSave()) : (_this3.state = "synchronized", _this3._pendingActions.remove(_this3._action), _this3._action = null);
          }).catch(function (t) {
            throw _this3.state = "error", _this3.state = "saving", _this3._debouncedSave(), t;
          }), this._savePromise);
        }
      }, {
        key: "_setPendingAction",
        value: function _setPendingAction() {
          var t = this.editor.t;
          this._action || (this._action = this._pendingActions.add(t("Saving changes")));
        }
      }, {
        key: "_saveCallbacks",
        get: function get() {
          var t = [];
          return this.adapter && this.adapter.save && t.push(this.adapter.save), this._config.save && t.push(this._config.save), t;
        }
      }]);
      return D;
    }(t.Plugin);
    (0, e.mix)(D, e.ObservableMixin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).autosave = n;
}();